// Shared Product Options data, importable from both the client page
// component and server route (JSON-LD generation).
export const productOptionsFaqs = [
  {
    question:
      "Can I customize the appearance of the options on my product pages?",
    answer:
      "Yes. Key Product Options automatically inherit your store's theme style. You can also customize layouts, colors, and fonts for a perfect brand match.",
  },
  {
    question: "Do I need coding skills to set up product options?",
    answer:
      "No. The app is fully no-code - all setup, styling, and logic are managed through an intuitive dashboard.",
  },
  {
    question: "Can I add price add-ons for specific options?",
    answer:
      "Absolutely. You can assign extra charges for premium materials, large sizes, gift wrapping, or any custom option.",
  },
  {
    question: "What is conditional logic, and how does it work?",
    answer:
      "Conditional logic lets you show or hide specific options based on customer selections, product tags, or other conditions. It keeps your product pages clean and relevant.",
  },
  {
    question: "Can customers upload files or images for personalization?",
    answer:
      "Yes. Customers can upload images, logos, or text files directly from the product page for personalized orders.",
  },
];

// Posts linked from /product-options. Ordered by commercial intent; the first
// two carry the "shopify variant limit" / "product options" queries in GSC.
export const productOptionsGuides = [
  {
    slug: "shopify-variant-limit-2026-all-workarounds",
    title: "Shopify variant limit 2026: every workaround compared",
    description:
      "The 100-variant limit and the 2,000-variant rollout explained, with split products, theme hacks and options apps side by side.",
  },
  {
    slug: "product-options-vs-variants-shopify-difference",
    title: "Product options vs variants on Shopify",
    description:
      "Variants are SKUs Shopify tracks; options are customizations layered on top. When to use each and how they combine.",
  },
  {
    slug: "product-options-for-print-on-demand-shopify",
    title: "Product options for print-on-demand stores",
    description:
      "File uploads, personalization pricing, conditional logic and fulfillment for print-on-demand on Shopify.",
  },
  {
    slug: "hulk-product-options-alternative-keystone",
    title: "Switching from Hulk Product Options",
    description:
      "What to look for in a replacement options app, and how Keystone compares on options, pricing and support.",
  },
];
